import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export default function IsAuthorized({ children }) {
  const { loading, user } = useAuthContext();

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
